
import React, { useEffect, useRef, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import hostlink from '../Hostlink/hostlink';
import * as XLSX from 'xlsx';
import {
    PDFDownloadLink,
    Document,
    Page,
    Text,
    View,
    StyleSheet
} from '@react-pdf/renderer';
import Loading from './Loading';

const FindLot = () => {

    const [isLoading, setIsLoading] = useState(false);

    const usershopid = localStorage.getItem('MYPCKARTUSER')
        ? JSON.parse(localStorage.getItem('MYPCKARTUSER'))[0].id
        : '0';

    const [data, setData] = useState([]);

    const today = new Date();

    const [frmdata, setfrmdata] = useState({
        fromdate: today.toISOString().split('T')[0],
        todate: today.toISOString().split('T')[0],
        deptcode: 0,
        lotno: "",
        status: 1
    });

    const {
        fromdate,
        todate,
        lotno
    } = frmdata;

    const tableRef = useRef(null);


    // =====================================================
    // INPUT CHANGE
    // =====================================================

    const onChangevalue = (e) => {

        const {
            name,
            value
        } = e.target;

        const sanitizedValue = value.replace(
            /['"!`@#$%^&*+{}|;:,.<>?=]/g,
            ''
        );

        setfrmdata({
            ...frmdata,
            [name]: sanitizedValue
        });
    };


    // =====================================================
    // LOAD DATA
    // =====================================================

    const loaddata = async () => {

        setIsLoading(true);

        try {

            const apidata =
                lotno === ""
                    ? `PurchaseMasFindAll/${usershopid}`
                    : `PurchaseMasFindAllSearch/${usershopid}/${lotno}`;

            const billResponse = await axios.get(
                `${hostlink}/${apidata}`
            );

            const responseData = billResponse.data || [];


            // -------------------------------------------------
            // FABRICATOR
            // -------------------------------------------------

            const fabnameDataMap = {};


            // -------------------------------------------------
            // WASHING
            // -------------------------------------------------

            const wnameDataMap = {};


            // -------------------------------------------------
            // FINISHING
            // -------------------------------------------------

            const finisharDataMap = {};


            responseData.forEach(item => {

                // FABRICATOR

                if (item.fabname) {

                    const fabKey =
                        `${item.fabcode}-${item.size}-${item.style}`;

                    if (!fabnameDataMap[fabKey]) {

                        fabnameDataMap[fabKey] = {

                            type: 'fabname',

                            fabname: item.fabname,

                            size: item.size,

                            style: item.style,

                            billno: item.billno,

                            pcs: Number(item.pcs) || 0,

                            fabcode: item.fabcode

                        };

                    } else {

                        fabnameDataMap[fabKey].pcs +=
                            Number(item.pcs) || 0;

                    }
                }


                // WASHING

                if (item.wname) {

                    const wKey =
                        `${item.wcode}-${item.size}-${item.style}`;

                    if (!wnameDataMap[wKey]) {

                        wnameDataMap[wKey] = {

                            type: 'wname',

                            wname: item.wname,

                            size: item.size,

                            style: item.style,

                            billno: item.billno,

                            washqty: Number(item.washqty) || 0,

                            wcode: item.wcode

                        };

                    } else {

                        wnameDataMap[wKey].washqty +=
                            Number(item.washqty) || 0;

                    }
                }


                // FINISHING

                if (item.finisharname) {

                    const finisharKey =
                        `${item.finisharcode}-${item.size}-${item.style}`;

                    if (!finisharDataMap[finisharKey]) {

                        finisharDataMap[finisharKey] = {

                            type: 'finisharname',

                            finisharname: item.finisharname,

                            size: item.size,

                            style: item.style,

                            billno: item.billno,

                            finishqty:
                                Number(item.finishqty) || 0,

                            finisharcode:
                                item.finisharcode

                        };

                    } else {

                        finisharDataMap[finisharKey].finishqty +=
                            Number(item.finishqty) || 0;

                    }
                }

            });


            const fabnameData =
                Object.values(fabnameDataMap)
                    .filter(item => item.pcs !== 0);


            const wnameData =
                Object.values(wnameDataMap)
                    .filter(item => item.washqty !== 0);


            const finisharData =
                Object.values(finisharDataMap)
                    .filter(item => item.finishqty !== 0);


            const result = [
                ...fabnameData,
                ...wnameData,
                ...finisharData
            ];


            console.log(
                "Filtered Data Found...",
                result
            );


            setData(result);

        } catch (error) {

            console.log(
                "Data Not Found...",
                error
            );

            setData([]);

        } finally {

            setIsLoading(false);

        }
    };


    // =====================================================
    // MASTER DATA
    // =====================================================

    useEffect(() => {

        axios
            .get(`${hostlink}/${usershopid}/FabMasCont`)
            .catch(() => {
                console.log("Fabricator data not found");
            });


        axios
            .get(`${hostlink}/${usershopid}/WasherMas`)
            .catch(() => {
                console.log("Washer data not found");
            });

    }, [usershopid]);


    // =====================================================
    // EXCEL
    // =====================================================

    const exportToExcel = () => {

        if (
            !tableRef.current ||
            data.length === 0
        ) {
            return;
        }


        const ws =
            XLSX.utils.table_to_sheet(
                tableRef.current
            );


        const wb =
            XLSX.utils.book_new();


        XLSX.utils.book_append_sheet(
            wb,
            ws,
            'Pending Lot'
        );


        XLSX.writeFile(
            wb,
            'Pending Lot.xlsx'
        );
    };


    // =====================================================
    // TYPE
    // =====================================================

    const getType = (res) => {

        return [

            res.fabname
                ? 'Fabricator'
                : '',

            res.wname
                ? 'Washing'
                : '',

            res.finisharname
                ? 'Finishing'
                : ''

        ]
            .filter(Boolean)
            .join(' | ');
    };


    // =====================================================
    // NAME
    // =====================================================

    const getName = (res) => {

        return [

            res.fabname
                ? res.fabname
                : '',

            res.wname
                ? res.wname
                : '',

            res.finisharname
                ? res.finisharname
                : ''

        ]
            .filter(Boolean)
            .join(' | ');
    };


    // =====================================================
    // PENDING PCS
    // =====================================================

    const getPendingPcs = (res) => {

        return [

            res.fabname
                ? `${res.pcs}`
                : '',

            res.wname
                ? `${res.washqty}`
                : '',

            res.finisharname
                ? `${res.finishqty}`
                : ''

        ]
            .filter(Boolean)
            .join(' | ');
    };


    // =====================================================
    // TOTAL
    // =====================================================

    const totalPending = data.reduce(
        (total, res) => {

            const pcs =
                res.fabname
                    ? parseFloat(res.pcs) || 0
                    : 0;

            const washqty =
                res.wname
                    ? parseFloat(res.washqty) || 0
                    : 0;

            const finishqty =
                res.finisharname
                    ? parseFloat(res.finishqty) || 0
                    : 0;

            return total +
                pcs +
                washqty +
                finishqty;

        },
        0
    );


    // =====================================================
    // UNIQUE LOTS
    // =====================================================

    const uniqueLots = [
        ...new Set(
            data
                .map(item => item.billno)
                .filter(Boolean)
        )
    ].length;


    // =====================================================
    // TYPE COUNTS
    // =====================================================

    const fabricatorCount =
        data.filter(
            item => item.fabname
        ).length;


    const washingCount =
        data.filter(
            item => item.wname
        ).length;


    const finishingCount =
        data.filter(
            item => item.finisharname
        ).length;


    return (

        <div
            className="container-fluid py-3"
            style={{
                minHeight: '100vh',
                background: '#f5f7fb'
            }}
        >


            {/* =================================================
                HEADER
            ================================================= */}

            <div className="row align-items-center mb-3">

                <div className="col-md-8">

                    <div className="d-flex align-items-center">

                        <div
                            className="d-flex align-items-center justify-content-center me-3"
                            style={{
                                width: '50px',
                                height: '50px',
                                borderRadius: '15px',
                                background:
                                    'linear-gradient(135deg,#0d6efd,#4f8dfd)',
                                color: '#fff',
                                boxShadow:
                                    '0 8px 22px rgba(13,110,253,.25)'
                            }}
                        >

                            <i
                                className="fa-solid fa-magnifying-glass"
                                style={{
                                    fontSize: '21px'
                                }}
                            ></i>

                        </div>


                        <div>

                            <h4 className="fw-bold mb-0">
                                Pending Lot
                            </h4>

                            <div
                                className="text-muted"
                                style={{
                                    fontSize: '13px'
                                }}
                            >
                                Track pending production by lot
                            </div>

                        </div>

                    </div>

                </div>


                <div className="col-md-4 text-md-end mt-3 mt-md-0">

                    <span
                        className="badge rounded-pill px-3 py-2"
                        style={{
                            background: '#fff',
                            color: '#495057',
                            border: '1px solid #e9ecef',
                            boxShadow:
                                '0 3px 12px rgba(0,0,0,.04)'
                        }}
                    >

                        <i className="fa-regular fa-calendar text-primary me-2"></i>

                        {fromdate}

                    </span>

                </div>

            </div>


            {/* =================================================
                SEARCH PANEL
            ================================================= */}

            <div
                className="card border-0 mb-3"
                style={{
                    borderRadius: '18px',
                    boxShadow:
                        '0 6px 25px rgba(31,45,61,.07)'
                }}
            >

                <div className="card-body p-3 p-md-4">

                    <div className="row align-items-end g-3">


                        {/* LOT NO */}

                        <div className="col-xl-6 col-lg-6 col-md-7">

                            <label
                                className="form-label fw-semibold mb-2"
                            >

                                <i className="fa-solid fa-barcode text-primary me-2"></i>

                                Search Lot Number

                            </label>


                            <div
                                className="input-group"
                                style={{
                                    height: '44px'
                                }}
                            >

                                <span
                                    className="input-group-text bg-white border-end-0"
                                >

                                    <i className="fa-solid fa-magnifying-glass text-muted"></i>

                                </span>


                                <input
                                    type="text"
                                    id="lotno"
                                    name="lotno"
                                    value={lotno}
                                    onChange={onChangevalue}
                                    onKeyDown={(e) => {

                                        if (e.key === 'Enter') {
                                            loaddata();
                                        }

                                    }}
                                    placeholder="Enter Lot No..."
                                    className="form-control border-start-0 border-end-0 ps-0"
                                    style={{
                                        boxShadow: 'none'
                                    }}
                                />


                                {lotno && (

                                    <button
                                        type="button"
                                        className="btn bg-white border border-start-0"
                                        onClick={() => {

                                            setfrmdata({
                                                ...frmdata,
                                                lotno: ""
                                            });

                                        }}
                                    >

                                        <i className="fa-solid fa-xmark text-muted"></i>

                                    </button>

                                )}

                            </div>


                            <small className="text-muted">
                                Search a specific lot or leave blank for all pending lots
                            </small>

                        </div>


                        {/* SHOW */}

                        <div className="col-xl-2 col-lg-2 col-md-5">

                            <button
                                type="button"
                                onClick={loaddata}
                                disabled={isLoading}
                                className="btn btn-primary w-100"
                                style={{
                                    height: '44px',
                                    borderRadius: '9px',
                                    boxShadow:
                                        '0 5px 15px rgba(13,110,253,.20)'
                                }}
                            >

                                <i className="fa-solid fa-magnifying-glass-chart me-2"></i>

                                Show

                            </button>

                        </div>


                        {/* EXCEL */}

                        <div className="col-xl-2 col-lg-2 col-md-6">

                            <button
                                type="button"
                                onClick={exportToExcel}
                                disabled={data.length === 0}
                                className="btn btn-success w-100"
                                style={{
                                    height: '44px',
                                    borderRadius: '9px'
                                }}
                            >

                                <i className="fa-solid fa-file-excel me-2"></i>

                                Excel

                            </button>

                        </div>


                        {/* PDF */}

                        <div className="col-xl-2 col-lg-2 col-md-6">

                            <PDFDownloadLink
                                document={
                                    <PDFDocument
                                        data={data}
                                        fromdate={fromdate}
                                        todate={todate}
                                    />
                                }
                                fileName="Pending Lot.pdf"
                                className="text-decoration-none"
                            >

                                {({ loading }) => (

                                    <button
                                        type="button"
                                        disabled={
                                            data.length === 0 ||
                                            loading
                                        }
                                        className="btn btn-danger w-100"
                                        style={{
                                            height: '44px',
                                            borderRadius: '9px'
                                        }}
                                    >

                                        <i className="fa-regular fa-file-pdf me-2"></i>

                                        {loading
                                            ? 'Loading'
                                            : 'PDF'}

                                    </button>

                                )}

                            </PDFDownloadLink>

                        </div>

                    </div>

                </div>

            </div>


            {/* =================================================
                SUMMARY CARDS
            ================================================= */}

            <div className="row g-3 mb-3">


                {/* TOTAL LOT */}

                <div className="col-xl-3 col-md-6">

                    <SummaryCard
                        title="Total Lots"
                        value={uniqueLots}
                        icon="fa-solid fa-boxes-stacked"
                        background="#eaf2ff"
                        iconColor="#0d6efd"
                    />

                </div>


                {/* RECORDS */}

                <div className="col-xl-3 col-md-6">

                    <SummaryCard
                        title="Total Records"
                        value={data.length}
                        icon="fa-solid fa-list"
                        background="#eeeaff"
                        iconColor="#6f42c1"
                    />

                </div>


                {/* PENDING */}

                <div className="col-xl-3 col-md-6">

                    <SummaryCard
                        title="Pending Pcs"
                        value={totalPending}
                        icon="fa-solid fa-cubes-stacked"
                        background="#e8f7ee"
                        iconColor="#198754"
                    />

                </div>


                {/* STATUS */}

                <div className="col-xl-3 col-md-6">

                    <SummaryCard
                        title="Process Types"
                        value={
                            `${fabricatorCount + washingCount + finishingCount}`
                        }
                        icon="fa-solid fa-layer-group"
                        background="#fff3cd"
                        iconColor="#997404"
                    />

                </div>

            </div>


            {/* =================================================
                TABLE CARD
            ================================================= */}

            <div
                className="card border-0"
                style={{
                    borderRadius: '18px',
                    overflow: 'hidden',
                    boxShadow:
                        '0 6px 25px rgba(31,45,61,.07)'
                }}
            >


                {/* TABLE HEADER */}

                <div
                    className="px-3 px-md-4 py-3 border-bottom d-flex justify-content-between align-items-center"
                    style={{
                        background: '#fff'
                    }}
                >

                    <div>

                        <h6 className="fw-bold mb-0">

                            <i className="fa-solid fa-table text-primary me-2"></i>

                            Pending Lot Details

                        </h6>

                        <small className="text-muted">
                            Fabricator, washing and finishing pending quantities
                        </small>

                    </div>


                    {lotno && (

                        <span
                            className="badge rounded-pill px-3 py-2"
                            style={{
                                background: '#eaf2ff',
                                color: '#0d6efd'
                            }}
                        >

                            <i className="fa-solid fa-barcode me-1"></i>

                            {lotno}

                        </span>

                    )}

                </div>


                {/* TABLE */}

                <div
                    className="table-responsive"
                    style={{
                        maxHeight: '620px'
                    }}
                >

                    <table
                        className="table table-hover align-middle mb-0"
                        ref={tableRef}
                    >

                        <thead
                            style={{
                                position: 'sticky',
                                top: 0,
                                zIndex: 5,
                                background: '#f8f9fa'
                            }}
                        >

                            <tr>

                                <th
                                    className="text-start px-3 py-3"
                                    style={{
                                        fontSize: '12px',
                                        color: '#6c757d',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    Lot No
                                </th>


                                <th
                                    className="text-start py-3"
                                    style={{
                                        fontSize: '12px',
                                        color: '#6c757d'
                                    }}
                                >
                                    Type
                                </th>


                                <th
                                    className="text-start py-3"
                                    style={{
                                        fontSize: '12px',
                                        color: '#6c757d'
                                    }}
                                >
                                    Name
                                </th>


                                <th
                                    className="text-end py-3"
                                    style={{
                                        fontSize: '12px',
                                        color: '#6c757d'
                                    }}
                                >
                                    Style
                                </th>


                                <th
                                    className="text-end py-3"
                                    style={{
                                        fontSize: '12px',
                                        color: '#6c757d'
                                    }}
                                >
                                    Size
                                </th>


                                <th
                                    className="text-end px-3 py-3"
                                    style={{
                                        fontSize: '12px',
                                        color: '#6c757d',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    Pending Pcs
                                </th>

                            </tr>

                        </thead>


                        <tbody>

                            {data.length === 0 ? (

                                <tr>

                                    <td
                                        colSpan="6"
                                        className="text-center py-5"
                                    >

                                        <div
                                            className="d-flex flex-column align-items-center"
                                        >

                                            <div
                                                className="d-flex align-items-center justify-content-center mb-3"
                                                style={{
                                                    width: '70px',
                                                    height: '70px',
                                                    borderRadius: '50%',
                                                    background: '#f1f3f5',
                                                    color: '#adb5bd'
                                                }}
                                            >

                                                <i
                                                    className="fa-solid fa-box-open"
                                                    style={{
                                                        fontSize: '27px'
                                                    }}
                                                ></i>

                                            </div>


                                            <h6 className="fw-bold mb-1">
                                                No Pending Lots Found
                                            </h6>


                                            <small className="text-muted">
                                                Enter a Lot No and click Show
                                            </small>

                                        </div>

                                    </td>

                                </tr>

                            ) : (

                                data.map((res, x) => {

                                    const isDuplicate =
                                        x > 0 &&
                                        res.billno ===
                                        data[x - 1].billno;

                                    const type =
                                        getType(res);

                                    const name =
                                        getName(res);

                                    const pending =
                                        getPendingPcs(res);


                                    return (

                                        <tr key={x}>


                                            {/* LOT */}

                                            <td
                                                className="text-start px-3"
                                            >

                                                {!isDuplicate && (

                                                    <span
                                                        className="badge rounded-pill"
                                                        style={{
                                                            background: '#eaf2ff',
                                                            color: '#0d6efd',
                                                            padding:
                                                                '7px 11px',
                                                            fontWeight: '600'
                                                        }}
                                                    >

                                                        {res.billno}

                                                    </span>

                                                )}

                                            </td>


                                            {/* TYPE */}

                                            <td className="text-start">

                                                {type
                                                    .split(' | ')
                                                    .map(
                                                        (
                                                            item,
                                                            index
                                                        ) => (

                                                            <span
                                                                key={index}
                                                                className="badge rounded-pill me-1 mb-1"
                                                                style={{
                                                                    background:
                                                                        item ===
                                                                            'Fabricator'
                                                                            ? '#eaf2ff'
                                                                            : item ===
                                                                                'Washing'
                                                                                ? '#e8f7ff'
                                                                                : '#fff3cd',

                                                                    color:
                                                                        item ===
                                                                            'Fabricator'
                                                                            ? '#0d6efd'
                                                                            : item ===
                                                                                'Washing'
                                                                                ? '#087990'
                                                                                : '#997404',

                                                                    fontWeight:
                                                                        '500'
                                                                }}
                                                            >

                                                                {item}

                                                            </span>

                                                        )
                                                    )}

                                            </td>


                                            {/* NAME */}

                                            <td
                                                className="text-start"
                                                style={{
                                                    fontWeight: '500'
                                                }}
                                            >

                                                {name}

                                            </td>


                                            {/* STYLE */}

                                            <td className="text-end">

                                                {res.style}

                                            </td>


                                            {/* SIZE */}

                                            <td className="text-end">

                                                {res.size}

                                            </td>


                                            {/* QTY */}

                                            <td
                                                className="text-end px-3"
                                            >

                                                <span
                                                    className="fw-bold"
                                                    style={{
                                                        color: '#198754'
                                                    }}
                                                >

                                                    {pending}

                                                </span>

                                            </td>


                                        </tr>

                                    );

                                })

                            )}


                            {/* TOTAL */}

                            {data.length > 0 && (

                                <tr
                                    style={{
                                        background: '#eef5ff',
                                        position: 'sticky',
                                        bottom: 0
                                    }}
                                >

                                    <td></td>

                                    <td></td>

                                    <td></td>

                                    <td></td>

                                    <td
                                        className="text-end fw-bold"
                                    >
                                        Total :
                                    </td>

                                    <td
                                        className="text-end px-3"
                                    >

                                        <span
                                            className="badge rounded-pill bg-primary px-3 py-2"
                                        >

                                            {totalPending}

                                        </span>

                                    </td>

                                </tr>

                            )}

                        </tbody>

                    </table>

                </div>


                {/* TABLE FOOTER */}

                {data.length > 0 && (

                    <div
                        className="px-3 px-md-4 py-3 border-top d-flex justify-content-between align-items-center"
                        style={{
                            background: '#fafbfc'
                        }}
                    >

                        <small className="text-muted">

                            Showing{' '}
                            <strong>
                                {data.length}
                            </strong>{' '}
                            records

                        </small>


                        <small className="text-muted">

                            Pending Quantity:{' '}

                            <strong className="text-success">
                                {totalPending}
                            </strong>

                        </small>

                    </div>

                )}

            </div>


            <ToastContainer autoClose={1000} />

            {isLoading && <Loading />}

        </div>
    );
};


// =========================================================
// SUMMARY CARD
// =========================================================

const SummaryCard = ({
    title,
    value,
    icon,
    background,
    iconColor
}) => {

    return (

        <div
            className="card border-0 h-100"
            style={{
                borderRadius: '15px',
                boxShadow:
                    '0 5px 20px rgba(0,0,0,.06)'
            }}
        >

            <div className="card-body">

                <div
                    className="d-flex justify-content-between align-items-center"
                >

                    <div>

                        <div className="text-muted small">
                            {title}
                        </div>

                        <h3
                            className="fw-bold mb-0 mt-1"
                        >
                            {value}
                        </h3>

                    </div>


                    <div
                        className="d-flex align-items-center justify-content-center"
                        style={{
                            width: '46px',
                            height: '46px',
                            borderRadius: '12px',
                            background: background,
                            color: iconColor
                        }}
                    >

                        <i className={icon}></i>

                    </div>

                </div>

            </div>

        </div>

    );
};


// =========================================================
// PDF DOCUMENT
// =========================================================

const PDFDocument = ({
    data,
    fromdate,
    todate
}) => {

    const getType = (res) => {

        return [
            res.fabname
                ? 'Fabricator'
                : '',

            res.wname
                ? 'Washing'
                : '',

            res.finisharname
                ? 'Finishing'
                : ''

        ]
            .filter(Boolean)
            .join(' | ');
    };


    const getName = (res) => {

        return [
            res.fabname
                ? res.fabname
                : '',

            res.wname
                ? res.wname
                : '',

            res.finisharname
                ? res.finisharname
                : ''

        ]
            .filter(Boolean)
            .join(' | ');
    };


    const getPendingPcs = (res) => {

        return [
            res.fabname
                ? `${res.pcs}`
                : '',

            res.wname
                ? `${res.washqty}`
                : '',

            res.finisharname
                ? `${res.finishqty}`
                : ''

        ]
            .filter(Boolean)
            .join(' | ');
    };


    const total = data.reduce(
        (total, res) => {

            const pcs =
                res.fabname
                    ? parseFloat(res.pcs) || 0
                    : 0;

            const wash =
                res.wname
                    ? parseFloat(res.washqty) || 0
                    : 0;

            const finish =
                res.finisharname
                    ? parseFloat(res.finishqty) || 0
                    : 0;

            return total +
                pcs +
                wash +
                finish;

        },
        0
    );


    return (

        <Document>

            <Page
                orientation="landscape"
                size="A4"
            >

                <View style={styles.container}>

                    <Text style={styles.title}>
                        Pending Lot
                    </Text>

                    <Text style={styles.subtitle}>
                        From {fromdate} To {todate}
                    </Text>


                    <View style={styles.table}>

                        <View style={styles.tableRow}>

                            <Text style={styles.headerCell}>
                                Lot No
                            </Text>

                            <Text style={styles.headerCell}>
                                Type
                            </Text>

                            <Text style={styles.headerCell}>
                                Name
                            </Text>

                            <Text style={styles.headerCell}>
                                Style
                            </Text>

                            <Text style={styles.headerCell}>
                                Size
                            </Text>

                            <Text style={styles.headerCell}>
                                Pending Pcs
                            </Text>

                        </View>


                        {data.map((res, x) => {

                            const isDuplicate =
                                x > 0 &&
                                res.billno ===
                                data[x - 1].billno;


                            return (

                                <View
                                    key={x}
                                    style={styles.tableRow}
                                >

                                    <Text style={styles.cell}>

                                        {!isDuplicate
                                            ? res.billno
                                            : ''}

                                    </Text>


                                    <Text style={styles.cell}>
                                        {getType(res)}
                                    </Text>


                                    <Text style={styles.cell}>
                                        {getName(res)}
                                    </Text>


                                    <Text style={styles.cell}>
                                        {res.style}
                                    </Text>


                                    <Text style={styles.cell}>
                                        {res.size}
                                    </Text>


                                    <Text style={styles.cell}>
                                        {getPendingPcs(res)}
                                    </Text>

                                </View>

                            );

                        })}


                        <View style={styles.tableRow}>

                            <Text style={styles.cell}></Text>

                            <Text style={styles.cell}></Text>

                            <Text style={styles.cell}></Text>

                            <Text style={styles.cell}></Text>

                            <Text style={styles.cell}>
                                Total :
                            </Text>

                            <Text style={styles.cell}>
                                {total}
                            </Text>

                        </View>

                    </View>

                </View>

            </Page>

        </Document>
    );
};


// =========================================================
// PDF STYLES
// =========================================================

const styles = StyleSheet.create({

    container: {
        padding: 20
    },

    title: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 5,
        textAlign: 'center'
    },

    subtitle: {
        fontSize: 9,
        marginBottom: 15,
        textAlign: 'center'
    },

    table: {
        display: 'table',
        width: '100%'
    },

    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderColor: '#cccccc'
    },

    headerCell: {
        fontSize: 8,
        fontWeight: 'bold',
        padding: 6,
        flex: 1,
        textAlign: 'center'
    },

    cell: {
        fontSize: 8,
        padding: 6,
        flex: 1,
        textAlign: 'center'
    }

});


export default FindLot;

